// src/components/jobDetails/OverviewTab.jsx
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
 // adjust path if needed

// Default marker fix (Leaflet doesn’t load icons correctly without this)
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

// WellMap component
const WellMap = ({ lat, lon }) => {
  if (!lat || !lon) return null;

  return (
    <div className="bg-gradient-to-br from-indigo-50 to-sky-50 dark:from-gray-800 dark:to-gray-900 p-4 rounded-xl border border-gray-100 dark:border-gray-700 shadow-sm">
      <div className="flex items-center justify-between mb-3">
        <h2 className="text-sm font-semibold text-indigo-800 dark:text-indigo-400 flex items-center gap-2">
          <div className="w-2 h-2 bg-indigo-500 rounded-full"></div>
          Well Location Map
        </h2>
        <div className="w-6 h-6 bg-indigo-100 dark:bg-indigo-900 rounded-full flex items-center justify-center">
          <span className="text-xs font-bold text-indigo-600 dark:text-indigo-300">🗺️</span>
        </div>
      </div>

      <div className="h-64 w-full rounded-lg overflow-hidden shadow">
        <MapContainer center={[lat, lon]} zoom={13} scrollWheelZoom={false} className="h-full w-full">
<TileLayer
  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
  attribution='&copy; OpenStreetMap contributors'
/>
          <Marker position={[lat, lon]}>
            <Popup>
              Well Location <br /> {lat.toFixed(4)}°, {lon.toFixed(4)}°
            </Popup>
          </Marker>
        </MapContainer>
      </div>
    </div>
  );
};
export default function OverviewTab({ jobInfo, wellInfo, currentRun }) {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-3">
      {/* Job Information Card */}
      <div className="bg-gradient-to-br from-blue-50 to-indigo-50 dark:from-gray-800 dark:to-gray-900 p-4 rounded-xl border border-gray-100 dark:border-gray-700 shadow-sm">
        <div className="flex items-center justify-between mb-3">
          <h2 className="text-sm font-semibold text-blue-800 dark:text-blue-400 flex items-center gap-2">
            <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
            Job Information
          </h2>
          <div className="w-6 h-6 bg-blue-100 dark:bg-blue-900 rounded-full flex items-center justify-center">
            <span className="text-xs font-bold text-blue-600 dark:text-blue-300">📋</span>
          </div>
        </div>
        
        <div className="space-y-2">
          <InfoRow label="Job No" value={jobInfo?.job_number} highlight />
          <InfoRow label="Customer" value={jobInfo?.customer_name?.customer_name} />
          <InfoRow label="Client" value={jobInfo?.client_name?.client_name} />
          <InfoRow label="Survey Method" value={jobInfo?.service_name?.service_name} />
          <InfoRow label="Well ID" value={jobInfo?.well_id} />
          <InfoRow label="Well Name" value={jobInfo?.well_name} />
          <InfoRow label="Arrival Date" value={jobInfo?.start_date} />
          <InfoRow label="Rig Number" value={jobInfo?.rig_number} />
        </div>
      </div>

      {/* Well Information Card */}
      <div className="bg-gradient-to-br from-green-50 to-emerald-50 dark:from-gray-800 dark:to-gray-900 p-4 rounded-xl border border-gray-100 dark:border-gray-700 shadow-sm">
  {/* Header */}
  <div className="flex items-center justify-between mb-4">
    <h2 className="text-sm font-semibold text-green-800 dark:text-green-400 flex items-center gap-2">
      <div className="w-2 h-2 bg-green-500 rounded-full"></div>
      Well Information
    </h2>
    <div className="w-6 h-6 bg-green-100 dark:bg-green-900 rounded-full flex items-center justify-center">
      <span className="text-xs font-bold text-green-600 dark:text-green-300">📍</span>
    </div>
  </div>

  {/* Coordinates Section */}
  <div className="mb-4">
    <h3 className="text-xs font-bold uppercase text-gray-500 dark:text-gray-400 mb-2">Coordinates</h3>
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2">
      <InfoRow
        label="Latitude (DMS)"
        value={
          wellInfo
            ? `${wellInfo.latitude_degrees}° ${wellInfo.latitude_minutes}' ${wellInfo.latitude_seconds}"`
            : "-"
        }
      />
      <InfoRow
        label="Longitude (DMS)"
        value={
          wellInfo
            ? `${wellInfo.longitude_degrees}° ${wellInfo.longitude_minutes}' ${wellInfo.longitude_seconds}"`
            : "-"
        }
      />
      <InfoRow label="Latitude" value={wellInfo ? `${wellInfo.north_coordinates}°N` : "-"} />
      <InfoRow label="Longitude" value={wellInfo ? `${wellInfo.east_coorinates}°E` : "-"} />
    </div>
  </div>

  {/* Projection Section */}
  <div className="mb-4">
    <h3 className="text-xs font-bold uppercase text-gray-500 dark:text-gray-400 mb-2">Projection</h3>
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2">
      <InfoRow label="Northing" value={wellInfo?.north_coordinates} />
      <InfoRow label="Easting" value={wellInfo?.easting_value} />
      <InfoRow label="Map Zone" value={wellInfo?.map_zone} />
      <InfoRow label="Central Meridian" value={wellInfo?.central_meridian} />
      <InfoRow label="Grid Correction" value={wellInfo?.grid_correction} />
      <InfoRow label="North Reference" value={wellInfo?.north_reference?.north_reference_name} />
     
    </div>
  </div>

  {/* Reference Systems Section */}
  <div>
    <h3 className="text-xs font-bold uppercase text-gray-500 dark:text-gray-400 mb-2">Reference Systems</h3>
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2">
      <InfoRow label="Reference Datum" value={wellInfo?.reference_datum} />
      <InfoRow label="Geodetic Datum" value={wellInfo?.geodetic_datum} />
      <InfoRow label="Geodetic System" value={wellInfo?.geodetic_system} />
       <InfoRow label="elevation_referred_to" value={wellInfo?.elevation_referred_to} />
    </div>
  </div>
</div>



      {/* Run Information Card */}
     {currentRun && (
  <div className="bg-gradient-to-br from-red-50 to-orange-50 dark:from-gray-800 dark:to-gray-900 p-4 rounded-xl border border-gray-100 dark:border-gray-700 shadow-sm">
    {/* Header */}
    <div className="flex items-center justify-between mb-3">
      <h2 className="text-sm font-semibold text-red-800 dark:text-red-400 flex items-center gap-2">
        <div className="w-2 h-2 bg-red-500 rounded-full"></div>
        Run Information
      </h2>
      <div className="w-6 h-6 bg-red-100 dark:bg-red-900 rounded-full flex items-center justify-center">
        <span className="text-xs font-bold text-red-600 dark:text-red-300">⚡</span>
      </div>
    </div>

    {/* Run Info Grid */}
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-3">
      <InfoRow label="Run No" value={currentRun.run_number} highlight />
      <InfoRow label="Survey From" value={`${currentRun.survey_from} m`} />
      <InfoRow label="Survey To" value={`${currentRun.survey_to} m`} />
      <InfoRow label="Survey Meterage" value={`${currentRun.survey_meterage} m`} />
      <InfoRow label="Survey Type" value={currentRun.survey_type_name} />
      <InfoRow label="Hole Section" value={currentRun.hole_section_name} />
      <InfoRow label="Survey Run In" value={currentRun.survey_run_in_name} />
      <InfoRow label="Minimum ID" value={currentRun.minimum_id_name} />
    </div>

    {/* Tie-On Section inside Run Info */}
    {currentRun?.tie_on && (
      <div className="mt-6">
        <h3 className="text-xs font-bold uppercase text-gray-500 dark:text-gray-400 mb-2">
          Tie-On Information
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-3">
          <InfoRow label="Measured Depth" value={`${currentRun.tie_on.md} m`} />
          <InfoRow label="TVD" value={`${currentRun.tie_on.tvd} m`} />
          <InfoRow label="Inclination" value={`${currentRun.tie_on.inc} °`} />
          <InfoRow label="Azimuth" value={`${currentRun.tie_on.az} °`} />
          <InfoRow label="NS" value={`${currentRun.tie_on.ns} m`} />
          <InfoRow label="EW" value={`${currentRun.tie_on.ew} m`} />
        </div>
      </div>
    )}
  </div>
)}


      {/* Quick Stats Card */}
      <div className="bg-gradient-to-br from-gray-50 to-slate-50 dark:from-gray-800 dark:to-gray-900 p-4 rounded-xl border border-gray-100 dark:border-gray-700 shadow-sm">
        <div className="flex items-center justify-between mb-3">
          <h2 className="text-sm font-semibold text-gray-800 dark:text-gray-300 flex items-center gap-2">
            <div className="w-2 h-2 bg-gray-500 rounded-full"></div>
            Quick Stats
          </h2>
          <div className="w-6 h-6 bg-gray-100 dark:bg-gray-700 rounded-full flex items-center justify-center">
            <span className="text-xs font-bold text-gray-600 dark:text-gray-400">📊</span>
          </div>
        </div>
        
        <div className="grid grid-cols-2 gap-3">
          <StatBox label="Total Runs" value={currentRun ? "1" : "0"} />
          <StatBox label="Survey Length" value={currentRun ? `${currentRun.survey_meterage}m` : "-"} />
          <StatBox label="Max Depth" value={currentRun ? `${currentRun.survey_to}m` : "-"} />
          <StatBox label="Status" value="Active" />
        </div>
      </div>
      {wellInfo && (
  <WellMap lat={wellInfo.north_coordinates} lon={wellInfo.east_coorinates} />
)}

      {/* Coordinates Card */}
      {wellInfo && (
        <div className="bg-gradient-to-br from-cyan-50 to-blue-50 dark:from-gray-800 dark:to-gray-900 p-4 rounded-xl border border-gray-100 dark:border-gray-700 shadow-sm">
          <div className="flex items-center justify-between mb-3">
            <h2 className="text-sm font-semibold text-cyan-800 dark:text-cyan-400 flex items-center gap-2">
              <div className="w-2 h-2 bg-cyan-500 rounded-full"></div>
              Coordinates
            </h2>
            <div className="w-6 h-6 bg-cyan-100 dark:bg-cyan-900 rounded-full flex items-center justify-center">
              <span className="text-xs font-bold text-cyan-600 dark:text-cyan-300">🌐</span>
            </div>
          </div>
          
          <div className="space-y-2">
            <CoordinateRow 
              label="Latitude DMS" 
              degrees={wellInfo.latitude_degrees}
              minutes={wellInfo.latitude_minutes}
              seconds={wellInfo.latitude_seconds}
              direction="N"
            />
            <CoordinateRow 
              label="Longitude DMS" 
              degrees={wellInfo.longitude_degrees}
              minutes={wellInfo.longitude_minutes}
              seconds={wellInfo.longitude_seconds}
              direction="E"
            />
          </div>
        </div>
      )}
    </div>
  );
}

// Info Row Component
function InfoRow({ label, value, highlight = false }) {
  return (
    <div className="flex items-center justify-between py-1">
      <span className={`text-xs ${highlight ? 'font-semibold text-gray-700 dark:text-gray-300' : 'text-gray-500 dark:text-gray-400'}`}>
        {label}
      </span>
      <span className={`text-xs font-mono ${highlight ? 'font-bold text-blue-600 dark:text-blue-400' : 'text-gray-700 dark:text-gray-300'}`}>
        {value || "-"}
      </span>
    </div>
  );
}

// Stat Box Component
function StatBox({ label, value }) {
  return (
    <div className="bg-white dark:bg-gray-800 p-2 rounded-lg text-center border border-gray-200 dark:border-gray-600">
      <div className="text-lg font-bold text-gray-800 dark:text-gray-200 mb-1">
        {value}
      </div>
      <div className="text-xs text-gray-500 dark:text-gray-400">
        {label}
      </div>
    </div>
  );
}

// Coordinate Row Component
function CoordinateRow({ label, degrees, minutes, seconds, direction }) {
  const hasData = degrees !== null && minutes !== null && seconds !== null;
  
  return (
    <div className="py-1">
      <div className="text-xs text-gray-500 dark:text-gray-400 mb-1">{label}</div>
      <div className="text-xs font-mono text-gray-700 dark:text-gray-300">
        {hasData ? (
          <span>
            {degrees}°{minutes}′{seconds}″ {direction}
          </span>
        ) : (
          "-"
        )}
      </div>
    </div>
  );
}